import React from 'react';

var SvgPasswordVisible = function SvgPasswordVisible(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 10.907c1.229 0 2.225-.996 2.225-2.225s-.996-2.225-2.225-2.225-2.225.996-2.225 2.225.996 2.225 2.225 2.225m0 1.02c1.792 0 3.245-1.453 3.245-3.245s-1.453-3.245-3.245-3.245-3.245 1.453-3.245 3.245 1.453 3.245 3.245 3.245",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.029 8.977c.577-1.65 2.77-4.977 6.971-4.977 4.2 0 6.394 3.328 6.971 4.977.093.266-.047.557-.313.65-.265.093-.556-.047-.65-.313-.504-1.441-2.42-4.294-6.008-4.294s-5.504 2.853-6.009 4.294c-.093.266-.384.406-.65.313-.265-.093-.405-.384-.312-.65",
    clipRule: "evenodd"
  }));
};
SvgPasswordVisible.displayName = "PasswordVisible";

export { SvgPasswordVisible as S };
